// Weekly targets parsed from the free-text cadence line. The corpus writes
// "Daily", "3 x per week", "2 to 3 x per week", "Weekly", "Nightly",
// "Monthly", "Once", "As needed", "Ongoing"... The daily check-list needs
// two things from that: how many times a week the practice asks for, and
// whether it is scheduled at all.
//
// Returns times per week. 0 means unscheduled ("Once", "As needed" and the
// other ambient kinds): never due on its own, listed under the check-list's
// More link, and counted for the day only when actually ticked.
export function weeklyTarget(cadence: string | null | undefined): number {
  const c = (cadence ?? "").trim().toLowerCase();
  const range = /(\d+)(?:\s*(?:to|-|–)\s*\d+)?\s*x?\s*(?:per|a|\/)\s*week/.exec(c);
  if (range) return Math.min(7, Math.max(1, Number(range[1])));
  if (/several times (per|a) week/.test(c)) return 4;
  if (/^weekly\b/.test(c)) return 1;
  if (/once|as needed|ongoing|monthly|seasonal|quarter|periodic|point of purchase|n\/a|not carried/.test(c)) return 0;
  // "Daily", "Nightly", "Every morning", "Every meal", "Every session" and
  // anything unparsed: a daily habit is the safe reading for a habit line.
  return 7;
}
